<template>
  <a @click="handleChange" type="text" :class="['sider-trigger-a']"><common-icon :type="collapsed?'_menu-fold':'_menu-unfold'" :size="24"/><!--<Icon :type="icon" :size="size" />--></a>
</template>
<script>
  import CommonIcon from '_c/common-icon'
export default {
  name: 'siderTrigger',
  props: {
    collapsed: Boolean,
    icon: {
      type: String,
      default: 'navicon-round'
    },
    size: {
      type: Number,
      default: 26
    }
  },
  components:{CommonIcon},
  methods: {
    handleChange () {
      this.$emit('on-change', !this.collapsed)
    }
  }
}
</script>
<style lang="less">
@import './sider-trigger.less';
</style>
